/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DodTestStartResponse } from "../models/dod-test-start-response";
import { DodTestRequest } from "../models/dod-test-request";
import { DodTestStatusRow } from "../models/dod-test-status-row";
@Injectable({
  providedIn: "root",
})
class AdminDodTestService extends __BaseService {
  static readonly adminDodTestStartPath = "/api/AdminDodTest/Start";
  static readonly adminDodTestGetStatusPath = "/api/AdminDodTest/Status";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param request undefined
   */
  adminDodTestStartResponse(
    request: DodTestRequest
  ): __Observable<__StrictHttpResponse<DodTestStartResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodTest/Start`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodTestStartResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodTestStart(
    request: DodTestRequest
  ): __Observable<DodTestStartResponse> {
    return this.adminDodTestStartResponse(request).pipe(
      __map((_r) => _r.body as DodTestStartResponse)
    );
  }
  adminDodTestGetStatusResponse(): __Observable<
    __StrictHttpResponse<Array<DodTestStatusRow>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminDodTest/Status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodTestStatusRow>>;
      })
    );
  }
  adminDodTestGetStatus(): __Observable<Array<DodTestStatusRow>> {
    return this.adminDodTestGetStatusResponse().pipe(
      __map((_r) => _r.body as Array<DodTestStatusRow>)
    );
  }
}

module AdminDodTestService {}

export { AdminDodTestService };
